import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ItmAbstractElementRef } from '../itm-abstract-element-ref';
import { NullTemplateVisitor } from '@angular/compiler';

@Component({
	selector: 'itm-button',
	templateUrl: './itm-button.component.html',
	styleUrls: ['./itm-button.component.scss']
})
export class ItmButtonComponent extends ItmAbstractElementRef {

	@Input() label: string;
	@Input() href: string;
	@Input() cssClass: string;
	@Input() disabled: boolean;
	@Input() dataTarget: string;
	@Input() dataToggle: string;
	@Input() ariaExpanded: string;
	@Input() ariaControls: string;
	@Input() ariaHasPopup: string;
	@Input() buttonType: string = "button";

	@Output() myClick = new EventEmitter<any>();

	constructor(el: ElementRef) {
		super(el);
	}

	onClick(evt: any): void {
		this.myClick.emit();
	}

}
